export const bodyTypeOptions = [
  { value: "sedan", title: "Sedan", title_ar: "سيدان" },
  { value: "hatchback", title: "Hatchback", title_ar: "هاتشباك" },
  { value: "suv", title: "SUV", title_ar: "دفع رباعي" },
  { value: "convertible", title: "Convertible", title_ar: "قابلة للتحويل" },
  { value: "pickup truck", title: "Pickup Truck", title_ar: "شاحنة صغيرة" },
  { value: "other", title: "Other", title_ar: "أخرى" },
];

export const nettierToolKitOptions = [
  { value: "basic", title: "Basic", title_ar: "أساسي" },
  { value: "standard", title: "Standard", title_ar: "قياسي" },
  { value: "advanced", title: "Advanced", title_ar: "متقدم" },
];

export const BuildInCameraOptions = [
  { value: "rearview", title: "Rearview", title_ar: "الرؤية الخلفية" },
  { value: "360", title: "360", title_ar: "رؤية 360" },
  { value: "front", title: "Front", title_ar: "الرؤية الأمامية" },
  { value: "side", title: "Side", title_ar: "الرؤية الجانبية" },
  { value: "parking_sensors", title: "Parking Sensors", title_ar: "مستشعرات وقوف السيارات" },
  { value: "dashcam", title: "Dashcam", title_ar: "كاميرا لوحة القيادة" },
  { value: "night_vision", title: "Night Vision", title_ar: "رؤية ليلية" },
  { value: "surround_view", title: "Surround View", title_ar: "رؤية محيطية" },
  { value: "driver_monitoring", title: "Driver Monitoring", title_ar: "مراقبة السائق" },
  { value: "reversing_with_parking_lines", title: "Reversing With Parking Lines", title_ar: "الرجوع مع خطوط الركن" },
  { value: "cabin", title: "Cabin", title_ar: "الكابينة" },
  { value: "trailer", title: "Trailer", title_ar: "المقطورة" },
];

export const lightingTypeOptions = [
  { value: "led", title: "LED", title_ar: "إضاءة LED" },
  { value: "xenon", title: "Xenon", title_ar: "إضاءة زينون" },
  { value: "halogen", title: "Halogen", title_ar: "إضاءة هالوجين" },
  { value: "laser", title: "Laser", title_ar: "إضاءة ليزر" },
  { value: "matrix_led", title: "Matrix LED", title_ar: "إضاءة LED المصفوفة" },
  { value: "oled", title: "OLED", title_ar: "إضاءة OLED" },
  { value: "adaptive_led", title: "Adaptive LED", title_ar: "إضاءة LED التكيفية" },
  { value: "bi_xenon", title: "Bi Xenon", title_ar: "إضاءة بي زينون" },
  { value: "drl", title: "DRL", title_ar: "إضاءة النهار DRL" },
  { value: "fog_lights", title: "Fog Lights", title_ar: "إضاءة الضباب" },
];

export const gearBoxOptions = [
  { value: "cvt", title: "CVT", title_ar: "ناقل حركة متغير مستمر" },
  { value: "at", title: "AT", title_ar: "ناقل الحركة AT" },
  { value: "mt", title: "MT", title_ar: "ناقل الحركة MT" },
  { value: "dct", title: "DCT", title_ar: "ناقل الحركة DCT" },
  { value: "semi_automatic", title: "Semi Automatic", title_ar: "شبه أوتوماتيكي" },
  { value: "electric_vehicle", title: "Electric Vehicle", title_ar: "سيارة كهربائية" },
];

export const driveTrainOptions = [
  { value: "fwd", title: "FWD", title_ar: "دفع أمامي" },
  { value: "4wd", title: "4WD", title_ar: "دفع رباعي" },
  { value: "rwd", title: "RWD", title_ar: "دفع خلفي" },
  { value: "AWD", title: "AWD", title_ar: "دفع رباعي دائم" },
  { value: "EAWD", title: "EAWD", title_ar: "دفع رباعي كهربائي" },
  { value: "fwd_and_electric", title: "FWD Electric", title_ar: "دفع أمامي كهربائي" },
  { value: "rwd_and_electric", title: "RWD Electric", title_ar: "دفع خلفي كهربائي" },
  { value: "hybrid", title: "Hybrid", title_ar: "هجين" },
];

export const fuelTypeOptions = [
  { value: "gasoline", title: "Gasoline", title_ar: "بنزين" },
  { value: "hybrid", title: "Hybrid", title_ar: "هجين" },
  { value: "diesel", title: "Diesel", title_ar: "ديزل" },
  { value: "plugin_hybrid", title: "Plugin Hybrid", title_ar: "هجين قابلة للشحن" },
  { value: "electric", title: "Electric", title_ar: "كهربائي" },
];

export const transmissionOptions = [
  { value: "Automatic", title: "Automatic", title_ar: "أوتوماتيكي" },
  { value: "Manual", title: "Manual", title_ar: "يدوي" },
];

export const roofOptions = [
  { value: "standard", title: "Standard", title_ar: "قياسي" },
  { value: "panoramic", title: "Panoramic", title_ar: "بانورامي" },
  { value: "convertible", title: "Convertible", title_ar: "قابل للتحويل" },
  { value: "hardtop", title: "Hardtop", title_ar: "سقف صلب" },
  { value: "softtop", title: "Softtop", title_ar: "سقف مرن" },
  { value: "targa", title: "Targa", title_ar: "تارغا" },
  { value: "moon", title: "Moon", title_ar: "سقف القمر" },
  { value: "fixed", title: "Fixed", title_ar: "ثابت" },
  { value: "railing", title: "Railing", title_ar: "قضبان السقف" },
  { value: "suv", title: "SUV", title_ar: "دفع رباعي" },
];
